import { Accordion, List, Stack, Text } from "basis";
import { Question } from "./Question";

function General({ initiallyOpen }) {
  return (
    <Accordion.Item initiallyOpen={initiallyOpen}>
      <Accordion.Item.Header>General</Accordion.Item.Header>
      <Accordion.Item.Content>
        <Stack gap="10">
          <Question
            title="Can I view my interest free plans?"
            productType="credit-card"
          >
            <Text>
              You can view all of your unexpired interest free purchases in LSC.
              Simply select your product and choose the 'Interest free' tab to
              show your active interest free purchases.
            </Text>
          </Question>
          <Question title="Can I access the Latitude Service Centre overseas?">
            <Text>
              Yes, you can access the Latitude Service Centre from anywhere in
              the world if you have internet connectivity.
            </Text>
          </Question>
          <Question title="Why did I get logged out of the Latitude Service Centre?">
            <Text>
              The Latitude Service Centre will automatically log you out after
              ten minutes of inactivity.
            </Text>
          </Question>
          <Question title="How do I reset my password?">
            <Text>
              Click on the 'Forgot password' link on the login page and follow
              the prompts.
            </Text>
          </Question>
          <Question title="How do I protect my password?">
            <Text>To protect your password we advise you:</Text>
            <br />
            <List>
              <List.Item>
                Don’t save any access codes on your computer or any personal
                devices
              </List.Item>
              <List.Item>Don’t write it down</List.Item>
              <List.Item>
                Don’t select a password that contains any personal details which
                can be guessed by others
              </List.Item>
              <List.Item>Don't reveal your password to others</List.Item>
              <List.Item>
                Never provide your access password on an email request
              </List.Item>
              <List.Item>Change your password regularly</List.Item>
            </List>
          </Question>
          <Question title="What should I do if my access has been compromised?">
            <Text>
              Inform Latitude immediately and we will ensure your account is
              secure.
            </Text>
          </Question>
          <Question
            title="Can I still use the Latitude Service Centre if one of my Latitude card products is stolen?"
            productType="credit-card"
          >
            <Text>
              Cancellation of your Latitude Card will not impact your ability to
              access the Latitude Service Centre.
            </Text>
          </Question>
          <Question
            title="Can additional card holders link their credit cards in the Latitude Service Centre?"
            productType="credit-card"
          >
            <Text>
              For privacy reasons, only the primary cardholder can link their
              account.
            </Text>
          </Question>
          <Question
            title="Where can I see my reward points?"
            productType="credit-card"
          >
            <Text>
              Your rewards points are on your statement. We plan to include
              rewards points in the Latitude Service Centre, in the future.
            </Text>
          </Question>
          <Question
            title="Can I still link my credit card if it's not activated?"
            productType="credit-card"
          >
            <Text>
              Yes, you will still be able to link your credit card through the
              Latitude Service Centre, even if it is not yet activated.
            </Text>
          </Question>
          <Question
            title="Can I see if I am behind in repaying my loan?"
            productType="personal-loan"
            region="NZ"
          >
            <Text>
              The Latitude Service Centre will show your current balance and
              monthly repayment amount, it will not reflect any overdue
              repayments on you loan. We will contact you if you fall behind in
              your repayments.
            </Text>
          </Question>
          <Question
            title="Can I see my repayments history in the Latitude Service Centre?"
            productType="personal-loan"
          >
            <Text>
              The Latitude Service Centre will show your current balance. We are
              working to bring you your payment history.
            </Text>
          </Question>
          <Question
            title="I see 'Monthly Repayment' on my statement, but I pay weekly/fortnightly?"
            productType="personal-loan"
          >
            <Text>
              Your loan contract will advise you of your minimum monthly
              payment, which will also be shown in the Latitude Service Centre.
              You can choose to split the payment into weekly or fortnightly
              amounts which will be debited from your nominated bank account at
              your nominated frequency.
            </Text>
          </Question>
          <Question
            title="What does 'Maturity Date' mean?"
            productType="personal-loan"
          >
            <Text>
              This is the date in your loan contract that your loan is required
              to be paid off in full. This date does not change if the loan is
              paid off early or late.
            </Text>
          </Question>
          <Question
            title="Will my interest rate change?"
            productType="personal-loan"
          >
            <Text>
              Depending on the product, your interest rate may change. Refer to
              your loan contract for your agreed interest rate.
            </Text>
          </Question>
          <Question
            title="Can I make a payment to my personal loan in the Latitude Service Centre?"
            productType="personal-loan"
          >
            <Text>
              Not yet, we plan to bring this functionality to the Latitude
              Service Centre in the future.
            </Text>
          </Question>
          <Question
            title="I see my repayment is due on the 31st but this month does not go to 31."
            productType="personal-loan"
          >
            <Text>
              The date is based on the date the loan was started. If the date is
              greater than the total days in that month your due date will be
              the last day of that month.
            </Text>
          </Question>
          <Question title="What currency is my account in?">
            <Text>
              If you have an Australian product, the currency will always be in
              AUD. If you have a New Zealand product, the currency will always
              be in NZD. This also applies if you have products from both
              regions linked.
            </Text>
          </Question>
        </Stack>
      </Accordion.Item.Content>
    </Accordion.Item>
  );
}

export { General };
